





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import CustomerSelection from '@/modules/reports/health-reports/components/CustomersSelection.vue';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import HealthReports from '@/modules/reports/health-reports/views/HealthReports.vue';
import { Customer } from '@/modules/customers/domain/customer';

@Component({
    name: 'customer-health-reports',
    components: { HealthReports, SectionTitle, CustomerSelection },
})
export default class CustomerHealthReports extends Vue {
    private step: number = 0;
    private selectedCustomer: Customer | null = null;

    get breadcrumbItems() {
        const items = [
            {
                text: 'Selección de clientes',
                disabled: false,
                href: '',
            },
        ];

        if (this.step != 0) {
            items.push({
                text: this.selectedCustomer ? this.selectedCustomer.name : '',
                disabled: true,
                href: '',
            });
        }

        return items;
    }

    selectCustomer(customer: Customer) {
        this.selectedCustomer = customer;
        this.step = 1;
    }

    @Watch('step')
    onStepChanged(value: number) {
        if (value == 0) {
            this.selectedCustomer = null;
        }
    }
}
